import { Parser } from '~/api';
import RequestService from './request';

class OverviewService {
    license(): Promise<void> {
        return RequestService.get('/license').then(Parser.parse);
    }
}

export default new OverviewService();
